// @flow

export default class CheckoutThreedsModeDecisionRuleInvalidException extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'CheckoutThreedsModeDecisionRuleInvalidException';
  }
}
